/**
 * home-bestsellers.js
 * Accessible tab switching for the Bestsellers section.
 * Vanilla ES module — no dependencies.
 * ARIA pattern: https://www.w3.org/WAI/ARIA/apg/patterns/tabs/
 */

document.querySelectorAll('[data-bestsellers]').forEach((section) => {
  const tabs     = Array.from(section.querySelectorAll('[role="tab"]'));
  const panels   = Array.from(section.querySelectorAll('[role="tabpanel"]'));
  const features = Array.from(section.querySelectorAll('[data-feature-for]'));

  if (tabs.length === 0) return;

  /**
   * Activate the tab whose aria-controls matches targetId.
   * Updates aria-selected, tabindex on all tabs, hidden on all product panels,
   * and hidden on all feature panels (one feature image per tab).
   */
  function activate(targetId) {
    tabs.forEach((tab) => {
      const isActive = tab.getAttribute('aria-controls') === targetId;
      tab.setAttribute('aria-selected', String(isActive));
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
      tab.classList.toggle('home-bestsellers__tab--active', isActive);
    });

    /* Cross-fade panels via .is-active class (CSS opacity transition).
       aria-hidden mirrors visibility for screen readers. The `hidden`
       attribute is intentionally NOT used because display:none can't
       transition and would break the grid-stack cross-fade. */
    panels.forEach((panel) => {
      const isActive = panel.id === targetId;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', String(!isActive));
    });

    features.forEach((feature) => {
      const isActive = feature.getAttribute('data-feature-for') === targetId;
      feature.classList.toggle('is-active', isActive);
      feature.setAttribute('aria-hidden', String(!isActive));
    });
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      activate(tab.getAttribute('aria-controls'));
    });

    /**
     * Keyboard navigation per ARIA APG tabs pattern:
     * ArrowRight / ArrowLeft — move focus between tabs (wraps)
     * Home  — first tab
     * End   — last tab
     * Enter / Space handled by click (button element)
     */
    tab.addEventListener('keydown', (event) => {
      const idx = tabs.indexOf(event.target);

      let targetTab = null;

      switch (event.key) {
        case 'ArrowRight':
          targetTab = tabs[(idx + 1) % tabs.length];
          break;
        case 'ArrowLeft':
          targetTab = tabs[(idx - 1 + tabs.length) % tabs.length];
          break;
        case 'Home':
          targetTab = tabs[0];
          break;
        case 'End':
          targetTab = tabs[tabs.length - 1];
          break;
        default:
          return;
      }

      event.preventDefault();
      if (targetTab) {
        targetTab.focus();
        activate(targetTab.getAttribute('aria-controls'));
      }
    });
  });
});
